import * as types from "./types";
import {
    getTaxListAxios,
    deleteTaxAxios,
    postTaxAxios,
    putTaxAxios,
    getTaxByIDAxios
} from "./services";

export async function getTaxListAction({ commit }) {
    commit(types.LOADING_TAX, true);
    try {
      const { data } = await getTaxListAxios();
      console.log("API response from Axios:", data);
  
      if (data && data.result && Array.isArray(data.result)) {
        commit(types.GET_TAX_LIST, data.result);
        return data;
      } else {
        console.warn("Unexpected API response structure:", data);
        return { result: [] };  // Return empty array to prevent errors
      }
    } catch (e) {
      console.error("Error fetching tax list:", e);
      throw e;
    } finally {
      commit(types.LOADING_TAX, false);
    }
  }
  
export async function removeTaxAction({ commit }, payload) {
    commit(types.LOADING_TAX, true);
    try {
        await deleteTaxAxios(payload);
        commit(types.REMOVE_TAX, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_TAX, false);
    }
}

export async function addTaxAction({ commit }, payload) {
    commit(types.LOADING_TAX, true);
    try {
        await postTaxAxios(payload);
        commit(types.ADD_TAX, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_TAX, false);
    }
}

export async function updateTaxAction({ commit }, payload) {
    commit(types.LOADING_TAX, true);
    try {
        await putTaxAxios(payload);
        commit(types.UPDATE_TAX, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_TAX, false);
    }
}


export async function getTaxByIDAction({commit}, payload) {
    commit(types.LOADING_TAX, true);
    try {
        
        const {data} = await getTaxByIDAxios(payload);
        commit(types.GET_TAXBYID, data.result);
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_TAX, false);
    }
   
}